<template>
  <ui-dialog
    :show="isOpen"
    scrollable
    persistent
    custom-class="services-dialog"
    max-width="625"
    @input="handleClose"
  >
    <template #header>
      <div class="services-dialog__title">
        {{ serviceTitle }}
      </div>
    </template>
    <template #default>
      <div class="services-dialog__container">
        <GmbServiceConfig
          :selected-service="selectedService"
          :currency="currency"
          class="services-dialog__content"
          @delete="handleServiceUpdate"
          @update="handleServiceUpdate"
          @close="handleClose"
        />
      </div>
    </template>
    <template #loader>
      <SectionLoader :status="isLoading" />
    </template>
  </ui-dialog>
</template>

<script>
import GmbServiceConfig from "./GmbServiceConfig.vue";
import SectionLoader from "@/components/Loader/SectionLoader.vue";
import gmbServicesMixin from "@/helpers/mixins/gmb-services";

export default {
  name: "GmbServicesEditDialog",
  mixins: [gmbServicesMixin],
  components: {
    GmbServiceConfig,
    SectionLoader
  },
  props: {
    isOpen: {
      type: Boolean,
      default: true
    },
    selectedService: {
      type: Object,
      required: true
    },
    currency: {
      type: String,
      required: true
    }
  },
  computed: {
    serviceTitle() {
      return this.selectedService.gmb_category
        ? this.$t("message.facilityDetails.services.editServices")
        : this.selectedService.gmb_service_type.display_name;
    }
  },

  methods: {
    async handleServiceUpdate(payload) {
      const serviceItems = {
        service_items: [payload]
      };
      this.detectChangesAndSendEvent(serviceItems, this.selectedService);
      await this.patchFacilityService(serviceItems);
      this.handleClose();
    },
    handleClose() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
.services-dialog {
  &__container {
    position: relative;
    max-width: 100%;
    overflow: hidden;
    display: flex;
    min-height: 302px;
  }

  &__title {
    @include font-size(22px);
    font-weight: 600;
    line-height: 26px;
    height: 30px;
    overflow: hidden;
    align-items: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: calc(100% - 40px);
    display: inline-block;
    vertical-align: text-top;
  }

  &__content {
    display: flex;
    flex-direction: column;
    width: 100%;
    flex-shrink: 0;
    max-width: 100%;
    height: 100%;
  }

  &__actions {
    display: flex;
    gap: $spacing;
    justify-content: center;
    flex-grow: 1;
    margin-bottom: $spacing * 3;
  }

  &__confirm-button {
    flex-grow: 1;
  }
}
</style>
